import React from 'react';
import firebase from 'firebase'

var config = {
  apiKey: "AIzaSyDkP_EYNm3QEqGJxCKli9oS1zPWj28MF8k",
  authDomain: "prettylashed-c38d7.firebaseapp.com",
  databaseURL: "https://prettylashed-c38d7.firebaseio.com",
  projectId: "prettylashed-c38d7",
  storageBucket: "prettylashed-c38d7.appspot.com",
  messagingSenderId: "616738726729"
};
firebase.initializeApp(config);

//Reference mailinglist collection

var mailingListRef = firebase.database().ref("mailingList");

let saveNewEntry = (email) =>{
  let newMailingListRef = mailingListRef.push();
  newMailingListRef.set({
   email: email,
  });
};


  // const MailingListSubmit = () =>{
  // const rootRef = firebase.database().ref().child('mailingList');
  // firebase.database().ref('mailingList' + userId).set({email: email});}

  // var newPostKey = firebase.database().ref().child('posts').push().key;


  function submitForm(e){
    e.preventDefault();
 
    var email = getInputVal('email');
 
    console.log(email);

    saveNewEntry(email);

    e.target.reset();

  
    }
  
   
   function getInputVal(id){
     return document.getElementById(id).value;
   };


 

  

const MailingList = () =>




(
  <section className="mailing-list">
    <div className="content">
      <div className="mailing-list-content">
        <h2>
          Do you <span className="love">love</span> Pretty and Lashed?
        </h2>
        <p>
          Sign up to recieve{' '}
          <span className="word-mark">
           <span className="love">Pretty and Lashed</span>
          </span>{' '}
          product news, promotions and updates.
        </p>
        <form id='mailingList' className="newsletter-form" method="post" noValidate onSubmit={submitForm}>
          <input
            className="email"
            required="required"
            placeholder="Email address"
            name="email"
            type="email"
            aria-label="Email"
          id="email"/>
          <button type="submit" className="submit">
            Sign up
          </button>
        </form>
      </div>
    </div>
  </section>
);

export default MailingList;



// WEBPACK FOOTER //
// ./src/components/global/MailingList.js